import koreanChickenStew from "../../data/korean-chicken-stew.json";
import tropicalCoconutSmoothie from "../../data/tropical-coconut-smoothie.json";

export const SEED_RECIPES: Array<Record<string, unknown> & { id: string }> = [
  koreanChickenStew,
  tropicalCoconutSmoothie,
];
